import { defineStore } from 'pinia';
import { ref } from 'vue';
import { SocialMedia } from '../../../../shared/types/SocialMedia';

export const useSocialMediaStore = defineStore('socialMedia', () => {
  const socialMedias = ref<SocialMedia>();

  return { socialMedias };
});
